import React from "react";
import Remove from "../../assets/svgs/Remove";
import User from "../../assets/svgs/User";
import { useRootContext } from "../../context";

function Single({ text, time }) {
  return (
    <div className="flex relative space-x-5 hover:bg-gray-100 bg-white shadow-md rounded cursor-pointer">
      <button className="absolute inset-y-0 my-auto -left-5 flex justify-center items-center w-8 h-8 rounded-full p-1 bg-pink-500 text-white shadow">
        <User />
      </button>
      <div className="p-1">
        <p className="text-xs">
          <small>{time}</small>
        </p>
        <p className="text-sm p-0.5">{text}</p>
      </div>
    </div>
  );
}

const Notifications = ({ showN, setShowN }) => {
  return (
    <div
      style={{ width: "270px", right: "-125px" }}
      className={`${showN ? " block " : " hidden "} absolute mx-auto top-14`}
    >
      <div
        onClick={() => setShowN((p) => !p)}
        className="fixed inset-0 m-auto z-10 bg-black bg-opacity-20"
      />
      <div className="relative bg-gray-100 rounded-2x12shadow-lg z-50">
        <div className=" relative flex justify-between items-center p-5">
          <div className="w-16 h-16 rounded-md bg-gray-100 absolute inset-x-0 mx-auto -top-3 transform rotate-45 -z-10" />
          <p className="w-12 text-center py-0.5 bg-gray-200 shadow rounded-full">
            42
          </p>
          <p className="text-black">Activity</p>
          <button onClick={() => setShowN(false)} className="w-12">
            <Remove />
          </button>
        </div>

        <div className="pt-2 pb-8 pl-8 pr-3 space-y-5 h-96 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
          <Single text="Antalya Saint Joined as employee" time="4 min ago" />
          <Single text="Saint Joined as employee" time="14 min ago" />
          <Single text="Antalya Saint Joined as employee" time="1 hour ago" />
          <Single text="Antalya Saint Joined as employee" time="4 min ago" />
          <Single text="Saint Joined as employee" time="14 min ago" />
          <Single text="Antalya Saint Joined as employee" time="1 hour ago" />
          <Single text="Antalya Saint Joined as employee" time="4 min ago" />
          <Single text="Saint Joined as employee" time="14 min ago" />
          <Single text="Antalya Saint Joined as employee" time="1 hour ago" />
          <Single text="Antalya Saint Joined as employee" time="4 min ago" />
          <Single text="Saint Joined as employee" time="14 min ago" />
          <Single text="Antalya Saint Joined as employee" time="1 hour ago" />
        </div>
      </div>
    </div>
  );
};

export default Notifications;
